export default __webpack_public_path__ + "static/media/arrow_menu_open.1a53ef41.svg";